'use strict';

import Swiper from 'swiper';

export default class KeyNumbers {
    constructor() {
        document.querySelectorAll('.flx_key_numbers .swiper').forEach((el) => {
            new Swiper(el, {
                slidesPerView: 'auto',
                spaceBetween: 0,
                grabCursor: true,
                speed: 600,
                loop: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
            });
        });
    }
}
